/**
 * Clinical notes (WP2-NOTES; BUILD-PLAN M10, chart-notes.md).
 *
 * Routes: `/notes` (Notes due: unsigned, missing, my drafts, signed) and
 * `/patients/$patientId/notes` (the patient's notes with the composer).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'notes',
    title: 'Clinical notes',
    version: '0.1.0',
    owner: 'WP2-NOTES',
    entitlementKey: null,
    permissions: ['notes.view', 'notes.sign', 'chart.edit'],
    routes: [
      {
        id: 'due',
        path: '/notes',
        title: 'Notes due',
        officeScope: 'location-or-all',
        permission: 'notes.view',
        readsPhi: true,
      },
      {
        id: 'patient',
        path: '/patients/$patientId/notes',
        title: 'Clinical notes',
        officeScope: 'location-or-all',
        permission: 'notes.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Notes',
        labelKey: 'clinicalNotes',
        group: 'clinical',
        routeId: 'due',
        icon: 'file-text',
        order: 50,
        permission: 'notes.view',
      },
    ],
    commands: [
      {
        id: 'notes.due',
        title: 'Open Notes due',
        keywords: ['sign', 'unsigned', 'clinical notes', 'missing notes'],
        routeId: 'due',
        permission: 'notes.view',
      },
    ],
    shortcuts: [{ keys: 'g n', description: 'Go to Notes due', routeId: 'due' }],
    sseEntityKeys: ['clinical_note', 'note_template'],
  }),
  pages: {
    due: () => import('./NotesDuePage.js'),
    patient: () => import('./PatientNotesPage.js'),
  },
});
